import { ApiProvider } from "@/context/api";
import { AuthenticatedRouteProvider } from "@/context/authenticated-route";
import { CurrentUserProvider } from "@/context/currentUser";
import { SettingsProvider } from "@/context/settings";
import { SystemProvider } from "@/context/system";
import { ToastProvider } from "@/context/toasts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type React from "react";

type Props = {
  customer: React.ComponentProps<typeof SettingsProvider>["customer"];
  system: Pick<React.ComponentProps<typeof SystemProvider>, "notifications">;
  user?: React.ComponentProps<typeof CurrentUserProvider>["user"];
  children: React.ReactNode;
};

const queryClient = new QueryClient();

export function Providers({ customer, system, user, children }: Props) {
  return (
    <QueryClientProvider client={queryClient}>
      <SettingsProvider customer={customer}>
        <SystemProvider notifications={system.notifications}>
          <ToastProvider>
            <ApiProvider>
              <AuthenticatedRouteProvider type={null}>
                <CurrentUserProvider user={user}>{children}</CurrentUserProvider>
              </AuthenticatedRouteProvider>
            </ApiProvider>
          </ToastProvider>
        </SystemProvider>
      </SettingsProvider>
    </QueryClientProvider>
  );
}
